import type { V2Inspection } from '../domain/inspection';
import { boundLicenseState } from './boundLicense';

// The licence gate of a FORMAL final report (Owner decision list 2026-10-19 items 11 and 50):
//   licenceMissing  the inspection carries no New York licence number, or the account has no bound
//                   licence (an inspection recorded before licences were bound must be bound first) —
//                   RPL §444-g(2) wants the licence number on every report, so this is a block, not a
//                   warning;
//   licenceExpired  the account's bound licence is past its expiry today (re-checked monthly, L-6).
// A Demo report is never blocked by it.
export type LicenceBlock = 'licenceMissing' | 'licenceExpired';

export function licenceBlockFor(inspection: V2Inspection, at: number = Date.now()): LicenceBlock | null {
  if (inspection.agreement.demo) return null;
  const inspector = inspection.inspector;
  if (inspector.licensedState !== 'NY' || inspector.licenseNumber.trim().length === 0) return 'licenceMissing';
  const state = boundLicenseState(at);
  if (state === 'unbound') return 'licenceMissing';
  if (state === 'expired') return 'licenceExpired';
  return null;
}
